if (!customElements.get('vv-catalog')) {
  customElements.define('vv-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-category-filter]');
        if (!button) return;
        const category = button.dataset.categoryFilter;
        this.querySelectorAll('[data-category-filter]').forEach((item) => {
          const active = item === button;
          item.setAttribute('aria-pressed', String(active));
          item.classList.toggle('vv-pill--active', active);
        });
        let count = 0;
        this.querySelectorAll('[data-product-category]').forEach((card) => {
          card.hidden = category !== 'all' && card.dataset.productCategory !== category;
          if (!card.hidden) count += 1;
        });
        const feature = this.querySelector('[data-catalog-feature]');
        if (feature) feature.hidden = category !== 'all' && category !== 'daily';
        this.querySelector('[data-filter-status]').textContent = this.dataset.countLabel.replace('[count]', count);
      });
    }
  });
}
